import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable, forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { HomeComponent } from './home.component';
import { HeaderService } from '../common/components/header/header.service';
import { SessionService } from '../common/services/session.service';
import { DashboardService } from '../dashboard/dashboard.service';

@Injectable({ providedIn: 'root' })
export class HomeResolver implements Resolve<HomeComponent> {
    constructor(
        private _dashboardService: DashboardService,
        private _headerService: HeaderService,
        private _sessionService: SessionService
    ) {}

    resolve(): Observable<any> {
        return forkJoin([this._dashboardService.getAccounts(), this._headerService.getUserProfileInfo(), this._headerService.checkForNewNotification()]).pipe(
            catchError((_error: any) => {
                this._sessionService.logout();
                return of(null);
            })
        );
    }
}
